import { styled } from '@mui/material'

export const TabContentContainer = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2, 2),
    width: '100%',
}))
